export const GET_DATA_REQUEST="GET_DATA_REQUEST";
export const GET_PHONES__DATA_SUCCESS="GET_PHONES__DATA_SUCCESS";
export const GET_DATA_FAILURE="GET_DATA_FAILURE";
export const GET_TV__DATA_SUCCESS="GET_TV__DATA_SUCCESS";
export const GET_LAPTOP__DATA_SUCCESS="GET_LAPTOP__DATA_SUCCESS";
export const GET_SINGLE_PRODUCT="GET_SINGLE_PRODUCT";
export const GET_CART_DATA="GET_CART_DATA"

